<template>
  <div class="lotto-result-page wrapper wrapper-content">
    <div class="container-fluid">
      <div class="row lottery-result">
        <div class="col-md-12">
          <div class="result-shell">
            <div class="result-tabs">
              <ul class="nav nav-tabs lotto-tabs">
                <li>
                  <router-link
                    :to="{ name: 'lottoresultbydate' }"
                    class="lotto-tab-link"
                    exact
                    active-class="is-active"
                  >
                    <i class="fa fa-fw fa-calendar"></i>
                    <span>ผลหวยเรียงตามวันที่</span>
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'lottoresultbytype' }"
                    class="lotto-tab-link"
                    active-class="is-active"
                  >
                    <i class="fa fa-fw fa-list"></i>
                    <span>ผลหวยเรียงตามประเภท</span>
                  </router-link>
                </li>
              </ul>
            </div>

            <div class="result-panel">
              <div class="result-toolbar">
                <div class="result-toolbar__header">
                  <div class="result-toolbar__eyebrow">Lottery Results</div>
                  <h2 class="result-toolbar__title">ตรวจผลหวยย้อนหลังตามวันที่</h2>
                  <p class="result-toolbar__subtitle">
                    เลือกวันที่เพื่อดูผลการละเล่นในแต่ละประเภท
                  </p>
                </div>

                <div class="result-toolbar__form-wrap">
                  <form id="date_result" @submit.prevent class="result-form">
                    <div class="lotto-date-field">
                      <span class="lotto-date-field__icon">
                        <i class="fa fa-calendar"></i>
                      </span>

                      <date-picker
                        v-model="date"
                        :config="options"
                        class="lotto-date-picker"
                      ></date-picker>
                    </div>
                  </form>

                  <div class="result-selected-date">
                    <i class="fa fa-clock-o"></i>
                    <span>ข้อมูลประจำวันที่ {{ current_date }}</span>
                  </div>
                </div>
              </div>

              <div class="row result-grid">
                <div class="col-xs-12 col-md-4 result-column">
                  <div class="result-card result-card--government">
                    <div class="result-card__header">
                      <h4 class="result-card__title">
                        {{ goves_result.description || 'หวยรัฐบาล' }}
                      </h4>
                    </div>

                    <div class="result-card__body">
                      <table class="table table-bordered lotto-table">
                        <thead>
                          <tr>
                            <th>รางวัลที่ออก</th>
                            <th>สามตัวบน</th>
                            <th>สองตัวล่าง</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span class="lotto-value" v-if="goves_result.full_result">
                                {{ goves_result.full_result }}
                              </span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                            <td>
                              <span class="lotto-value" v-if="goves_result.threetop">
                                {{ goves_result.threetop }}
                              </span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                            <td>
                              <span class="lotto-value" v-if="goves_result.twodown">
                                {{ goves_result.twodown }}
                              </span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    class="result-card result-card--special"
                    v-if="sp_indexes_result['25'].description"
                  >
                    <div class="result-card__header">
                      <h4 class="result-card__title">
                        {{ sp_indexes_result['25'].description }} -
                        {{ sp_indexes_result['25'].result_date }}
                      </h4>
                    </div>

                    <div class="result-card__body">
                      <table class="table table-bordered lotto-table">
                        <thead>
                          <tr>
                            <th>รางวัลที่ออก</th>
                            <th>สามตัวบน</th>
                            <th>สองตัวล่าง</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span :class="sp_indexes_result['25'].full_result ? 'lotto-value' : 'lotto-empty'">
                                {{ sp_indexes_result['25'].full_result || 'รอผล' }}
                              </span>
                            </td>
                            <td>
                              <span :class="sp_indexes_result['25'].threetop ? 'lotto-value' : 'lotto-empty'">
                                {{ sp_indexes_result['25'].threetop || 'รอผล' }}
                              </span>
                            </td>
                            <td>
                              <span :class="sp_indexes_result['25'].twodown ? 'lotto-value' : 'lotto-empty'">
                                {{ sp_indexes_result['25'].twodown || 'รอผล' }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    class="result-card result-card--special"
                    v-if="sp_indexes_result['26'].description"
                  >
                    <div class="result-card__header">
                      <h4 class="result-card__title">
                        {{ sp_indexes_result['26'].description }} -
                        {{ sp_indexes_result['26'].result_date }}
                      </h4>
                    </div>

                    <div class="result-card__body">
                      <table class="table table-bordered lotto-table">
                        <thead>
                          <tr>
                            <th>รางวัลที่ออก</th>
                            <th>สามตัวบน</th>
                            <th>สองตัวล่าง</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span :class="sp_indexes_result['26'].full_result ? 'lotto-value' : 'lotto-empty'">
                                {{ sp_indexes_result['26'].full_result || 'รอผล' }}
                              </span>
                            </td>
                            <td>
                              <span :class="sp_indexes_result['26'].threetop ? 'lotto-value' : 'lotto-empty'">
                                {{ sp_indexes_result['26'].threetop || 'รอผล' }}
                              </span>
                            </td>
                            <td>
                              <span :class="sp_indexes_result['26'].twodown ? 'lotto-value' : 'lotto-empty'">
                                {{ sp_indexes_result['26'].twodown || 'รอผล' }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="result-card result-card--thai">
                    <div class="result-card__header">
                      <h4 class="result-card__title">หวยหุ้นไทย - {{ current_date }}</h4>
                    </div>

                    <div class="result-card__body">
                      <table class="table table-bordered lotto-table">
                        <thead>
                          <tr>
                            <th>รอบ</th>
                            <th>สามตัวบน</th>
                            <th>สองตัวล่าง</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in thai_indexes_result"
                            :key="'t_indexes-' + index"
                          >
                            <th class="lotto-label">{{ item.description }}</th>
                            <td>
                              <span class="lotto-value" v-if="item.threetop">{{ item.threetop }}</span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                            <td>
                              <span class="lotto-value" v-if="item.twodown">{{ item.twodown }}</span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-md-4 result-column">
                  <div class="result-card result-card--foreign">
                    <div class="result-card__header">
                      <h4 class="result-card__title">หวยหุ้นต่างประเทศ - {{ current_date }}</h4>
                    </div>

                    <div class="result-card__body">
                      <table class="table table-bordered lotto-table">
                        <thead>
                          <tr>
                            <th>รอบ</th>
                            <th>สามตัวบน</th>
                            <th>สองตัวล่าง</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in foriegn_indexes_result"
                            :key="'f_indexes-' + index"
                          >
                            <th class="lotto-label">{{ item.description }}</th>
                            <td>
                              <span class="lotto-value" v-if="item.threetop">{{ item.threetop }}</span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                            <td>
                              <span class="lotto-value" v-if="item.twodown">{{ item.twodown }}</span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-md-4 result-column">
                  <div class="result-card result-card--yeekee">
                    <div class="result-card__header">
                      <h4 class="result-card__title">จับยี่กี - {{ current_date }}</h4>
                    </div>

                    <div class="result-card__body">
                      <table class="table table-bordered lotto-table">
                        <thead>
                          <tr>
                            <th>รอบ</th>
                            <th>สามตัวบน</th>
                            <th>สองตัวล่าง</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in yeekees_result"
                            :key="'yeekees-' + index"
                          >
                            <th class="lotto-label">{{ item.description }}</th>
                            <td>
                              <span class="lotto-value" v-if="item.threetop">{{ item.threetop }}</span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                            <td>
                              <span class="lotto-value" v-if="item.twodown">{{ item.twodown }}</span>
                              <span class="lotto-empty" v-else>รอผล</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div><!-- /result-shell -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

moment.locale('th')

export default {
    name: 'lottoresultbydate',
    data () {
        return {
            date: new Date(),
            goves_result: {},
            yeekees_result: [],
            foriegn_indexes_result: [],
            thai_indexes_result: [],
            current_date: moment(new Date()).format('LL'),
            isLoadingResult: false,
            suppressDateWatch: true,
            options: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
                widgetPositioning: {
                    horizontal: 'auto',
                    vertical: 'bottom'
                }
            },
            sp_indexes_result: {
                '25': {},
                '26': {}
            }
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        })
    },
    watch: {
        date: {
            async handler () {
                if (this.suppressDateWatch) return
                await this.processForm()
            }
        }
    },
    methods: {
        async processForm () {
            if (this.isLoadingResult) return

            let rawDate = this.date

            if (typeof rawDate === 'string') {
                const parts = rawDate.split('/')
                if (parts.length === 3) {
                    rawDate = new Date(parts[2], parts[1] - 1, parts[0])
                }
            }

            this.current_date = moment(rawDate).format('LL')
            const dateResult = moment(rawDate).format('YYYY-MM-DD')

            this.thai_indexes_result = []
            this.foriegn_indexes_result = []

            await this.loadLottoResult(dateResult)
        },

        async loadLottoResult (dateResult) {
            if (this.isLoadingResult) return

            if (!dateResult) {
                const hr = moment().hour()

                if (hr < 5) {
                    dateResult = moment().subtract(1, 'days').format('YYYY-MM-DD')
                } else {
                    dateResult = moment().format('YYYY-MM-DD')
                }
            }

            this.isLoadingResult = true

            try {
                const response = await this.$store.dispatch('lottoresult/getLottoResultByDate', dateResult)

                this.goves_result = {}
                this.yeekees_result = []
                this.foriegn_indexes_result = []
                this.thai_indexes_result = []
                this.sp_indexes_result = {
                    '25': {},
                    '26': {}
                }

                if (response.goves && response.goves.length > 0) {
                    this.goves_result = response.goves[0]

                    const thDate = this.formatThDate(response.goves[0].date_result)
                    this.goves_result.description = 'หวยรัฐบาล - ' + thDate

                    if (response.goves[0].threefront && response.goves[0].threeback) {
                        const [threefrontObj] = JSON.parse(response.goves[0].threefront)
                        const [threebackObj] = JSON.parse(response.goves[0].threeback)

                        this.goves_result.threefront = threefrontObj.first + ' ' + threefrontObj.second
                        this.goves_result.threeback = threebackObj.first + ' ' + threebackObj.second
                    }
                }

                this.yeekees_result = response.yeekees || []
                this.formatIndexLotto(response.indexes || [])

                if (response && response.sp_indexes) {
                    if (response.sp_indexes['25'] && response.sp_indexes[25] && response.sp_indexes[25].length > 0) {
                        for (let i = 0; i < response.sp_indexes[25].length; i++) {
                            const tempData = response.sp_indexes[25][i]
                            if (tempData.full_result && tempData.full_result > 0) {
                                this.sp_indexes_result['25'] = tempData
                                this.sp_indexes_result['25'].result_date = this.formatThDate(tempData.date_result)
                                break
                            }
                        }
                    }

                    if (response.sp_indexes['26'] && response.sp_indexes[26] && response.sp_indexes[26].length > 0) {
                        for (let i = 0; i < response.sp_indexes[26].length; i++) {
                            const tempData = response.sp_indexes[26][i]
                            if (tempData.full_result && tempData.full_result > 0) {
                                this.sp_indexes_result['26'] = tempData
                                this.sp_indexes_result['26'].result_date = this.formatThDate(tempData.date_result)
                                break
                            }
                        }
                    }
                }
            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                this.isLoadingResult = false
            }
        },

        formatIndexLotto (data) {
            for (let i = 0; i < data.length; i++) {
                const resultItem = data[i]
                const regex = /ไทยเย็น/ig
                const result = regex.test(resultItem.description)

                if (result) {
                    this.thai_indexes_result.push(resultItem)
                } else {
                    const round = resultItem.round

                    if (round > 18 && round < 22) {
                        continue
                    } else if (round === 25 || round === 26) {
                        continue
                    }

                    this.foriegn_indexes_result.push(resultItem)
                }
            }
        },

        formatDate (value) {
            if (value) {
                const date = new Date(value)
                return moment(date).format('DD/MM/YYYY HH:mm:ss')
            }
            return ''
        },

        formatThDate (value) {
            if (value) {
                const date = new Date(value)
                return moment(date).format('LL')
            }
            return ''
        }
    },
    async created () {
        await this.loadLottoResult()
        this.suppressDateWatch = false
    }
}
</script>

<style lang="sass" scoped>
.lotto-result-page
  padding-top: 96px !important
  padding-bottom: 24px
  background: transparent

.result-shell
  position: relative
  z-index: 2

.result-tabs
  margin-bottom: 14px
  position: relative
  z-index: 3

.lotto-tabs
  display: flex
  flex-wrap: wrap
  gap: 10px
  border-bottom: 0
  margin: 0
  padding: 0
  list-style: none

.lotto-tabs > li
  float: none
  margin: 0

.lotto-tab-link
  display: inline-flex
  align-items: center
  justify-content: center
  gap: 8px
  min-height: 46px
  padding: 11px 18px
  border-radius: 14px
  border: 1px solid rgba(201, 165, 92, .24)
  background: rgba(26, 79, 75, .84)
  color: #e9f4f3 !important
  font-size: 14px
  font-weight: 600
  line-height: 1.2
  text-decoration: none !important
  box-shadow: 0 8px 18px rgba(26, 79, 75, .10)
  transition: background .2s ease, color .2s ease, border-color .2s ease, transform .2s ease, box-shadow .2s ease

.lotto-tab-link:hover,
.lotto-tab-link:focus
  background: rgba(35, 94, 89, .96)
  border-color: rgba(212, 178, 107, .42)
  color: #fff6df !important
  transform: translateY(-1px)
  text-decoration: none !important
  outline: none

.lotto-tab-link.is-active
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%)
  border-color: rgba(201, 165, 92, .48)
  color: #fff6df !important
  box-shadow: 0 10px 24px rgba(26, 79, 75, .20)

.result-panel
  background: linear-gradient(180deg, rgba(255,255,255,.98) 0%, rgba(247,250,250,.98) 100%)
  border: 1px solid rgba(26, 79, 75, .10)
  border-radius: 20px
  box-shadow: 0 14px 40px rgba(26, 79, 75, .08)
  padding: 18px
  position: relative
  z-index: 1

.result-toolbar
  margin-bottom: 16px
  padding: 16px
  border-radius: 18px
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%)
  border: 1px solid rgba(212, 178, 107, .22)
  box-shadow: inset 0 1px 0 rgba(255,255,255,.08)

.result-toolbar__header
  margin-bottom: 12px

.result-toolbar__eyebrow
  font-size: 11px
  text-transform: uppercase
  letter-spacing: 1.8px
  color: rgba(255, 236, 197, .78)
  margin-bottom: 6px

.result-toolbar__title
  margin: 0 0 6px
  font-size: 24px
  line-height: 1.25
  font-weight: 700
  color: #fff8ea

.result-toolbar__subtitle
  margin: 0
  font-size: 14px
  line-height: 1.65
  color: rgba(220, 240, 238, .84)

.result-form
  margin-bottom: 10px

.lotto-date-field
  display: flex
  align-items: stretch
  width: 100%
  position: relative
  z-index: 5

.lotto-date-field__icon
  display: flex
  align-items: center
  justify-content: center
  min-width: 46px
  border: 1px solid rgba(212, 178, 107, .28)
  border-right: 0
  border-radius: 14px 0 0 14px
  background: rgba(255,255,255,.14)
  color: #fff4dc

::v-deep .lotto-date-picker
  flex: 1 1 auto
  width: 100%

::v-deep .lotto-date-picker input.form-control
  width: 100% !important
  height: 46px
  border: 1px solid rgba(212, 178, 107, .28)
  border-radius: 0 14px 14px 0 !important
  background: rgba(255,255,255,.97) !important
  color: #173321 !important
  box-shadow: none !important
  font-size: 14px
  padding-left: 14px
  padding-right: 14px

::v-deep .lotto-date-picker input.form-control:focus
  border-color: #d7b066 !important
  box-shadow: 0 0 0 2px rgba(215, 176, 102, .14) !important

::v-deep .lotto-date-picker .dropdown-menu,
::v-deep .bootstrap-datetimepicker-widget,
::v-deep .datepicker-dropdown
  z-index: 9999 !important
  min-width: 100% !important
  width: 100% !important
  max-width: 100% !important
  border-radius: 14px !important
  overflow: hidden
  box-shadow: 0 16px 40px rgba(26, 79, 75, .18)

.result-selected-date
  display: inline-flex
  align-items: center
  gap: 8px
  padding: 8px 12px
  border-radius: 999px
  background: rgba(255,255,255,.10)
  color: #f0f7f6
  font-size: 13px
  border: 1px solid rgba(255,255,255,.10)

.result-grid
  margin-left: -8px
  margin-right: -8px

.result-column
  padding-left: 8px
  padding-right: 8px
  margin-bottom: 16px

.result-card
  margin-bottom: 16px
  border-radius: 18px
  overflow: hidden
  background: #ffffff
  border: 1px solid rgba(26, 79, 75, .10)
  box-shadow: 0 8px 22px rgba(26, 79, 75, .06)

.result-card__header
  padding: 14px 16px
  border-bottom: 1px solid rgba(26, 79, 75, .08)
  background: linear-gradient(135deg, rgba(248, 251, 251, 1) 0%, rgba(240, 247, 247, 1) 100%)

.result-card__title
  margin: 0
  font-size: 20px
  line-height: 1.35
  font-weight: 700
  letter-spacing: -.2px

.result-card__body
  padding: 0

.result-card--government .result-card__title
  color: #156fa5

.result-card--thai .result-card__title
  color: #d88b2d

.result-card--foreign .result-card__title
  color: #df4e61

.result-card--yeekee .result-card__title
  color: #c2415d

.result-card--special .result-card__title
  color: #1A4F4B

.lotto-table
  margin-bottom: 0
  background: transparent

.lotto-table > thead > tr > th
  background: #edf3f3
  color: #1A4F4B !important
  border-color: #cfe0df !important
  font-size: 14px
  font-weight: 700
  padding: 14px 16px
  vertical-align: middle

.lotto-table > tbody > tr > th,
.lotto-table > tbody > tr > td
  border-color: #daeaea !important
  padding: 14px 16px
  vertical-align: middle
  background: #ffffff
  font-size: 15px
  color: #1e2e2d

.lotto-table > tbody > tr:nth-child(even) > th,
.lotto-table > tbody > tr:nth-child(even) > td
  background: #f8fcfc

.lotto-label
  color: #235E59
  font-weight: 600
  width: 38%

.lotto-value
  display: inline-block
  font-size: 15px
  font-weight: 700
  color: #184eb8

.lotto-empty
  display: inline-block
  font-size: 14px
  font-weight: 600
  color: #8b9a9a

@media (max-width: 991px)
  .lotto-result-page
    padding-top: 84px !important

  .result-panel
    padding: 14px

  .result-toolbar
    padding: 14px

  .result-toolbar__title
    font-size: 22px

  .result-card__title
    font-size: 18px

  .lotto-table > thead > tr > th,
  .lotto-table > tbody > tr > th,
  .lotto-table > tbody > tr > td
    padding: 12px 12px
    font-size: 14px

@media (max-width: 767px)
  .lotto-result-page
    padding-top: 76px !important
    padding-bottom: 18px

  .lotto-tabs
    gap: 8px

  .lotto-tabs > li
    width: 100%

  .lotto-tab-link
    width: 100%

  .result-panel
    border-radius: 18px
    padding: 12px

  .result-toolbar
    padding: 13px
    border-radius: 16px

  .result-toolbar__title
    font-size: 20px

  .result-toolbar__subtitle
    font-size: 13px

  .result-selected-date
    width: 100%
    justify-content: center
    font-size: 12px

  .result-card
    border-radius: 16px

  .result-card__header
    padding: 12px 14px

  .result-card__title
    font-size: 17px

  .lotto-table
    table-layout: fixed

  .lotto-table > thead > tr > th,
  .lotto-table > tbody > tr > th,
  .lotto-table > tbody > tr > td
    padding: 10px 10px
    word-break: break-word

  .lotto-label
    width: 42%

  .lotto-value
    font-size: 14px
</style>